import type { DashboardService } from '../api/DashboardService';
import type { DrillingAnalysisGroup, Formation, StratUnit } from '../api/IDashboardService';

type StratigraphyResponse = {
  stratUnits: StratUnit[];
  formations: Formation[];
};

export class WellIntervalsService {
  constructor(private readonly dashboardService: DashboardService) {}

  async fetchStratigraphyHeaders(wellboreId: number): Promise<StratigraphyResponse> {
    const [columnsResponse, lithologiesResponse] = await Promise.all([
      this.dashboardService.getStratColumnsByWellboreId(wellboreId),
      this.dashboardService.getLithologyByWellboreId(wellboreId),
    ]);

    const [stratUnits, formations] = await Promise.all([
      columnsResponse.data.length > 0 ? this.fetchStratUnits(columnsResponse.data[0].id) : Promise.resolve([]),
      lithologiesResponse.data.length > 0 ? this.fetchFormations(lithologiesResponse.data[0].id) : Promise.resolve([]),
    ]);

    return { stratUnits, formations };
  }

  async fetchStratUnits(columnId: number): Promise<StratUnit[]> {
    const { data } = await this.dashboardService.getStratUnitsByStratColumnId(columnId);
    return data;
  }

  async fetchFormations(lithologyId: number): Promise<Formation[]> {
    const { data } = await this.dashboardService.getFormationsByLithologyId(lithologyId);
    return data;
  }

  async fetchDrillingAnalysis(wellboreId: number): Promise<DrillingAnalysisGroup[]> {
    const { data } = await this.dashboardService.getCorridorsByWellboreId(wellboreId);
    return data;
  }

  async fetchSections(wellId: number) {
    const { data } = await this.dashboardService.getSequenceByWellId(wellId);
    return data;
  }
}
